export const environment = {
  name: 'dev',
  production: false,
  apiUrl: 'https://dev.pmservicetrack.com/api',
  wsUrl: 'wss://pm-api-dev-fbgyccftarf8f2dz.centralus-01.azurewebsites.net',
  appName: 'Walgreens PMS - Development',
  version: '1.0.0',
  enableLogging: true,
  enableMocking: false,
  agGridLicenseKey: '', // Add your AG Grid Enterprise license key here

  // OAuth2 Configuration for Microsoft Azure AD
  oauth: {
    authorizeUrl:
      'https://login.microsoftonline.com/4d0b6875-b2c8-427f-abd8-d3bd86a51515/oauth2/v2.0/authorize',
    tokenUrl:
      'https://login.microsoftonline.com/4d0b6875-b2c8-427f-abd8-d3bd86a51515/oauth2/v2.0/token',
    logoutUrl:
      'https://login.microsoftonline.com/4d0b6875-b2c8-427f-abd8-d3bd86a51515/oauth2/v2.0/logout',
    clientId: 'd865afc2-9ca9-43a8-8d2e-dc60a66b3515',
    scope: 'api://8d32d6ef-c1d3-454d-beac-1d789f433170/access_as_user offline_access',
    redirectUri: null, // Dynamically determined (localhost bridge for dev)
    responseType: 'code',
    grantType: 'authorization_code',
    usePKCE: true,
    codeChallenge: 'S256',
  },

  // PingFederate OIDC Configuration
  pingFederate: {
    authorizeUrl: 'https://ssotest.walgreens.com/as/authorization.oauth2',
    tokenUrl: 'https://ssotest.walgreens.com/as/token.oauth2',
    logoutUrl: 'https://ssotest.walgreens.com/idp/idpLogout',
    userinfoUrl: 'https://ssotest.walgreens.com/idp/userinfo.openid',
    jwksUri: 'https://ssotest.walgreens.com/pf/JWKS',
    issuer: 'https://ssotest.walgreens.com',
    clientId: 'SPA',
    scope: 'openid email profile offline_access',
    emailDomain: '@walgreenstest.com',
    redirectUri: null as string | null,
    responseType: 'code',
    grantType: 'authorization_code',
    usePKCE: true,
    codeChallenge: 'S256',
  },

  // Development flags
  development: {
    useOAuthBridge: true, // Enable OAuth bridge for localhost
    mockAuthentication: true, // Enable mock auth for testing
  },

  features: {
    enableRealtimeUpdates: true,
    enableOfflineMode: false,
    enableAnalytics: false,
    enableErrorReporting: false,
    enableOpeningClosingLocations: true,
    enableScenarios: true,
  },

  // Minutes of inactivity before the warning dialog appears (logout happens 60s later).
  // Change to 29 for production (warning at 29 min, auto-logout at 30 min).
  // DEV: show the idle warning after 2 minutes for local timeout testing.
  sessionTimeoutMinutes: 2,
};
